import { useEffect } from 'react';
import { Header, ContentContainer, Card, CardContent } from 'prosci-ui';
import { usePageContext } from '@/contexts/page-context';
import { AgentSettingsTab } from '../kaiya-config/agent-settings-tab';

export function KaiyaAgentSettingsPage() {
  const { setShowPageHeader } = usePageContext();

  useEffect(() => {
    setShowPageHeader(false);
    return () => setShowPageHeader(true);
  }, [setShowPageHeader]);

  return (
    <>
      <Header
        title="Agent Settings"
        description="Configure runtime parameters for Kaiya's AI pipeline"
      />
      <ContentContainer>
        <Card>
          <CardContent className="p-6">
            <AgentSettingsTab />
          </CardContent>
        </Card>
      </ContentContainer>
    </>
  );
}
